import { gql } from '@apollo/client';

export const ADYEN_CANCEL_CARD_ADD = gql`
  mutation AdyenCancelCardAdd($input: AdyenCancelCardAddInput!) {
    adyenCancelCardAdd(input: $input)
  }
`;
